import { isNil } from 'lodash-es';

import {
  QuestionBase,
  type IQuestionBase,
  type SetValueOptions,
} from './question-base';

export interface IQuestionCheckbox extends IQuestionBase<boolean> {}

export class QuestionCheckbox
  extends QuestionBase<boolean>
  implements IQuestionCheckbox
{
  constructor(options: IQuestionCheckbox) {
    super(options);

    if (!isNil(this.initialValue)) {
      this.initialValue = !!this.initialValue;
    }

    if (!isNil(this.defaultValue)) {
      this.defaultValue = !!this.defaultValue;
    }

    this.elementType = 'checkbox';
  }

  public override equals(value: any): boolean {
    return this.getValue() === value;
  }

  public override getValue(): boolean {
    const value = super.getValue();

    if (!isNil(value)) {
      return !!value;
    }

    return value;
  }

  public override setValue(
    value: any,
    opts: SetValueOptions = { emitEvent: true, force: false },
  ): void {
    if (!isNil(value)) {
      value = !!value;
    }

    super.setValue(value, opts);
  }
}
